import React from 'react'
import styled from 'styled-components'
import { injectIntl} from 'react-intl'


const Wrapper = styled.div`
    display:flex;
    flex-direction: column;
    align-items:center;
    justify-content:center;
    color: ${p=>p.theme.colors.on.warning};
    min-height:160px;
    padding:15px;
    background: repeating-linear-gradient( 45deg, #fff, #fff 4px, ${p=>p.theme.colors.warning} 2px, ${p=>p.theme.colors.warning} 6px )


`

const IconWrapper = styled.div`
    background-color:white;
    border: 1px solid ${p=>p.theme.colors.border.warning};
    border-radius:50%;
    height: 50px;
    width: 50px;

    display:flex;
    align-items:center;
    justify-content:center;
`

const Icon = styled.div`
    font-size: 24px;
    top:-1px;
    color: ${p=>p.theme.colors.on.warning};

`

const Panel = styled.div`
    background-color:white;
    border: 1px solid ${p=>p.theme.colors.border.warning};
    padding: 10px 10px;
    margin-top:5px;
    margin-bottom:5px;
    border-radius: 10px;
    text-align:center;
`

const Label = styled.div`
`

const Hint = styled.div`
    maring-top:5px;
    padding-top:5px;
    border-top: 1px solid ${p=>p.theme.colors.border.warning};
    font-size:0.8rem;

`


const HiddenComponnet = injectIntl( props => {

    const { icon = 'fad fa-eye-slash', hint } = props;
    return (
        <Wrapper>
            <IconWrapper>
                <Icon className={icon}/>
            </IconWrapper>
            <Panel>
            <Label>{props.intl.formatMessage({id:'Hidden component'})}</Label>
            {
                hint && <Hint>{props.intl.formatMessage({id:hint})}</Hint>
            }
            </Panel>
        </Wrapper>
    )
})

export default HiddenComponnet